const root = 'planDowngradeModal'

export const TestId = {
  root,
  title: `${root}-title`,
  successAlert: `${root}-successAlert`,
  closeButton: `${root}-closeButton`,
  cancelButton: `${root}-cancelButton`,
  confirmButton: `${root}-confirmButton`,
}
